import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { TOGGLE_LAYOUT } from '../../../store/layout/Actions';
import {
  CustomBadge,
  CustomBreadCrumb,
  CustomButton,
  PageTitle,
} from '../../../Components';
import {
  useLayoutDetection,
  useSelectedTheme,
  useTranslate,
} from '../../../Hooks';
import CustomHistoryTabsComponent from '../../../Components/V2/CustomHistoryComponent/CustomHistoryComponentTabs';
import { AgentWalletConfigurationPath } from './I18n/AgentWalletConfigurationLocale';
import AgentWalletConfigurationContent from './components/AgentWalletConfigurationContent';
import { useVerticalNav } from '../../../Contexts/VerticalNavContext';

import {
  GetAgentWalletConfiguration,
  SendAgentWalletConfiguration,
} from '../../../Services';

import { ClockIcon } from '../../../assets/icons';

import useStyles from './styles';
function AgentWalletConfigurationView() {
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const { translate } = useTranslate(AgentWalletConfigurationPath);
  const isNewLayout = isReskinningLayout && hasNewLayout;
  const dispatch = useDispatch();
  const { setAlertBoxContent } = useVerticalNav();

  const {
    theme: { palette },
  } = useSelectedTheme();
  const styles = useStyles();
  useEffect(() => {
    if (!isNewLayout) {
      dispatch(TOGGLE_LAYOUT());
    }
  }, []);

  const initialStateRef = useRef(null);

  const [state, setState] = useState({
    minuteCost: 0,
    minimumTopUp: 0,
    maximumTopUp: 0,
    overdraftEnabled: false,
    overdraftMinutes: 0,
    overdraftWarningMessage: '',
    lowBalanceThresholds: 0,
    overdraftWarningThresholds: 0,
    notificationTemplate: '',
  });

  const [isOpenHistory, setIsOpenHistory] = useState(false);

  const handleSendConfiguration = async () => {
    try {
      await SendAgentWalletConfiguration(state);
      setAlertBoxContent({
        display: true,
        variant: 'success',
        title: 'Configuration saved successfully',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
      reload();
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: 'error',
        title: 'Error in sendConfigurationContent',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  const getAgentWalletConfiguration = async () => {
    try {
      const result = await GetAgentWalletConfiguration();
      initialStateRef.current = { ...result };
      setState(result);
    } catch {
      setAlertBoxContent({
        display: true,
        variant: 'error',
        title: 'Error in getAgentWalletConfiguration',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  const reload = () => {
    getAgentWalletConfiguration();
  };

  useEffect(() => {
    getAgentWalletConfiguration();
  }, []);

  return isNewLayout ? (
    <Box className={styles.container}>
      <CustomBreadCrumb
        breadcrumbs={[
          {
            label: translate('bread-crump-parent'),
            nonClickable: true,
          },
        ]}
      >
        <CustomBadge
          Style={{
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '20px',
          }}
          label={translate('bread-crump-current')}
          BackgroundColor={palette.breadcrumbs.brand_bg_hover}
          BorderColor={palette.breadcrumbs.brand_bg_hover}
          Color={palette.breadcrumbs.brand_fg_hover}
        />
      </CustomBreadCrumb>
      <Box className={styles.headerWrapper}>
        <PageTitle
          wrapperClasses={styles.title}
          title={translate('page-title')}
          subTitle={translate('page-subtitle')}
          hideDivider
        >
          <Box className={styles.buttonWrapper}>
            <CustomButton
              size='lg'
              color='secondary'
              variant='outlined'
              onClick={() => setState(initialStateRef.current)}
              boxShadow='xs'
            >
              Discard
            </CustomButton>
            <CustomButton
              onClick={handleSendConfiguration}
              size='lg'
              boxShadow='xs'
            >
              save
            </CustomButton>
          </Box>
        </PageTitle>
        <CustomButton
          boxShadow='none'
          variant='text'
          size='md'
          color='tertiary'
          onClick={() => {
            setIsOpenHistory(true);
          }}
          startIcon={
            <ClockIcon
              width='20'
              height='20'
              fill={palette.button.tertiary_fg}
            />
          }
        >
          History
        </CustomButton>
      </Box>
      <AgentWalletConfigurationContent
        setState={setState}
        state={state}
      />
      <CustomHistoryTabsComponent
        isOpen={isOpenHistory}
        isOpenChanged={() => setIsOpenHistory(false)}
        typeId={'agentWalletHistory'}
        activeItem={initialStateRef.current}
      />
    </Box>
  ) : null;
}

export default AgentWalletConfigurationView;
